import { useEffect } from 'react';
import Lenis from 'lenis';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import { LanguageProvider } from './i18n';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Catalog } from './components/Catalog';
import { Technology, Marquee, About } from './components/Story';
import { Footer } from './components/Footer';
import { Magnets } from './components/Magnets';
import './App.css';
import './responsive.css';

const Site = () => {
  const reduced = useReducedMotion();
  const isMagnets = window.location.pathname.replace(/\/+$/, '') === '/magnets';
  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, syncTouch: false, anchors: { offset: -90 }, autoRaf: true, prevent: node => node.hasAttribute('data-lenis-prevent') });
    return () => lenis.destroy();
  }, [reduced]);
  useEffect(() => {
    const targetId = window.location.hash.slice(1);
    if (!targetId) return undefined;
    const timer = window.setTimeout(() => {
      const target = document.getElementById(targetId);
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
    }, 120);
    return () => window.clearTimeout(timer);
  }, [reduced, isMagnets]);
  return <><Header/>{isMagnets ? <Magnets/> : <main><Hero/><Catalog/><Technology/><Marquee/><About/></main>}<Footer/></>;
};

export default function App() {
  return <LanguageProvider><MotionConfig reducedMotion="user" transition={{ duration: .56, ease: [0.22, 1, 0.36, 1] }}><Site/></MotionConfig></LanguageProvider>;
}
